import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useActions } from '../../../Actions';
import { useAccountId } from '../../../auth/useAccountId';

import { State } from '../../../reducer';
import { namespace } from '../../transactionDetails';
import { namespace as messagesNamespace } from '../../../messages';
import { canExtendAuthorization } from '../../transactionHelpers';

import Page, { CustomBack, Title } from '../../../components/Page';
import Card from '../../../components/Card';
import ExtendForm from './ExtendForm';
import NotFound from '../../transactionDetails/components/NotFound';
import { LoadingOverlay } from '../../../components/Loading';
import ExtendError from './ExtendError';
import { H2, Text } from '../../../components/Typography';

const ExtendTransaction = () => {
    const { t } = useTranslation();
    const accountId = useAccountId();
    const transactionId = useParams<{transactionId: string}>().transactionId;
    const { extendTransaction, setView, closeErrorModal } = useActions(namespace);
    const { transaction, isLoading, isNotFound, error } = useSelector<State, State[typeof namespace]>(
        (s) => s[namespace]
    );
    const { addMessage } = useActions(messagesNamespace);
    const showSuccessMessage = () => {
        addMessage({
            text: t('payments.extendTransaction.success.title'),
            severity: 'success',
        });
    };

    if (transaction && !canExtendAuthorization(transaction)) {
        return <Page
            title={<><CustomBack onClick={() => setView('details')} /><Title>{t('payments.extendTransaction.form.title')}</Title></>}
            hasEnvFrame={true}
        >
            <Card noPadding={isNotFound}>
                <H2>{t('payments.extendTransaction.form.not_possible')}</H2>
                <Text>The reason for this could be that 14 days have not passed since the latest authorization expiration date, the authorization was extended today, the max extend limit has been reached, or the transaction does not have a positive capture amount.</Text>
            </Card>
        </Page>;
    }

    return <Page
        title={<><CustomBack onClick={() => setView('details')} /><Title>{t('payments.extendTransaction.form.title')}</Title></>}
        hasEnvFrame={true}
    >
        <Card noPadding={isNotFound}>
            {transaction && <ExtendForm
                transaction={transaction}
                extendTransaction={extendTransaction}
                accountId={accountId}
                isLoading={isLoading}
                showSuccessMessage={showSuccessMessage}
            />}
            {isLoading && <LoadingOverlay />}
            {isNotFound && <NotFound transactionId={transactionId} />}
        </Card>
        {error && <ExtendError error={error} transaction={transaction} dismissModal={closeErrorModal} />}
    </Page>;
};

export default ExtendTransaction;
